import { render, staticRenderFns } from "./collect-customer-edit.vue?vue&type=template&id=5a6c3db6&scoped=true&"
import script from "./collect-customer-edit.vue?vue&type=script&lang=ts&"
export * from "./collect-customer-edit.vue?vue&type=script&lang=ts&"
import style0 from "./collect-customer-edit.vue?vue&type=style&index=0&id=5a6c3db6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6c3db6",
  null
  
)

export default component.exports